
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import VTable from '@/components/shared/table/VTable.vue';
import ConstrainFilter from '@/components/constrain/ConstrainFilter.vue';
import headers from './headers';
import { Tag } from '@/interfaces/models/Tag';
import { Constrain } from '@/interfaces/models/Constrain';
import { Permission } from '@/enums/Permission';

@Component({
  components: { VTable, ConstrainFilter },
})
export default class ConstrainTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: Tag[];
  @Prop({ type: Number, required: true }) public total!: number;

  public headers: ColumnHeader[] = headers;

  public edit(item: Constrain) {
    this.$router.push({ name: 'constrain.edit', params: { id: item._id }, query: { ...this.$route.query } });
  }

  public canToggleActivation(val: boolean) {
    return val ? this.$can(Permission.CONSTRAIN_ACTIVATE) : this.$can(Permission.CONSTRAIN_DEACTIVATE);
  }
}
